<template>
  <b-modal id="social-sso-linked-modal" footer-class="border-0 justify-content-center" body-class="text-center" centered
    no-close-on-backdrop no-close-on-esc hide-header hide-header-close @show="onShowModal">
    <template #modal-footer>
      <b-button id="button-sso-linked-account-ok" class="border-0" pill @click="closeModal">
        {{ content.btnLabel }}
      </b-button>
    </template>
    <h3>{{ content.heading }}</h3>
    <p class="mb-0" v-html="content.message" :key="renderKey"></p>
  </b-modal>
</template>

<script>
import { getSsoUserCookie, hasCookie, removeSsoUserCookie } from '@/utilities';

export default {
  data() {
    return {
      socialSSOProvider: '',
      renderKey: 0
    };
  },
  computed: {
    content() {
      return {
        heading: 'Account linked successfully',
        message: `Your ${this.socialSSOProvider} account is now linked. You can now log in using ${this.socialSSOProvider}.`,
        btnLabel: 'Got it'
      };
    }
  },
  methods: {
    onShowModal() {
      this.$store.commit('customer/SET_LOADING', { key: 'socialCustomerLoading', value: false });
      this.socialSSOProvider = hasCookie('sso_user') && getSsoUserCookie('sso_user').provider || '';
      this.renderKey++;
    },
    closeModal() {
      this.$root.$emit('bv::hide::modal', 'social-sso-linked-modal');
      removeSsoUserCookie('sso_user');
      this.socialSSOProvider = '';
    }
  }
}
</script>

<style lang="scss" scoped>
#social-sso-linked-modal {
  .modal-content {
    max-width: 503px;
  }

  h3 {
    color: #2F3941;
    font-family: 'SKModernistBold', sans-serif;
    font-size: 1.25rem;
    margin-bottom: 24px;
  }

  p {
    color: #68737D;
    font-size: 1rem;
  }

  #button-sso-linked-account-ok {
    background-color: var(--main-color, #ff8a00);
    color: var(--button-text-color, #FFFFFF);
    font-family: 'SKModernistBold', sans-serif;
    font-size: 1rem;
    height: 44px;
    min-width: 183px;
  }
}
</style>

<style lang="scss">
#social-sso-linked-modal {
  .modal-content {
    border: 0;
    border-radius: 10px;
    padding-top: 25px;
  }

  .modal-body {
    padding-inline: 46px;
  }

  .modal-footer {
    padding-top: 16px;
    padding-bottom: 32px;
  }
}
</style>
